import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SurveyResponsePage } from './pages/SurveyResponsePage';

/**
 * Public survey response routes (no authentication required)
 * Pattern: /survey/:instanceId/*
 */
export const SurveyResponseRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Main survey response route */}
      <Route path="/" element={<SurveyResponsePage />} />

      {/* Redirect any sub-paths to main route */}
      <Route path="/*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
